import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const GuardedAdminRoute = ({ component: Component, role, ...rest }) => {
  let _user = JSON.parse(localStorage.getItem('user'))
  const user = _user?.user


  return (
    <Route
      {...rest}
      render={(props) => {
        let roles = [
          "IVR_ADMIN",
          "IVR_ADMIN_ASSISTANT"
        ]
        if (role) {
          roles = roles.filter(r => r == role)
        }
        if (user) {
          if (roles.includes(user.role)) {
            return <Component {...props} />
          }
          if (user.role === 'IVR_USER') {
            return <Redirect to="/dashboard" />
          }
        }
        return <Redirect to="/login" />
      }
        // user && user.role === 'IVR_ADMIN' || user.role === "IVR_ADMIN_ASSISTANT" ? (
        //   <Component {...props} {...rest} />
        // ) : user && user.role === 'IVR_USER' ? (
        //   <Redirect to="/dashboard" />
        // ) : (
        //   <Redirect to="/login" />
        // )
      }
    />
  )
}

export default GuardedAdminRoute